<template>
    <div>
        <div class="like_share_wrap b-0">
            <ul class="like_share_list">
                <li><router-link to="" class="btn btn-likes" @click="copyUrl"><i class="fas fa-share px-2"></i>{{ $t('share') }}</router-link></li>
                <li><a :href="'https://wa.me/' + props.item?.whatsapp + '?text=' + encodeURIComponent(messageToSend)" class="btn btn-likes" target="_blank"><i class="fab fa-whatsapp px-2"></i>{{ $t('chat on whatsapp') }}</a></li>
            </ul>
        </div>
        <div class="details-sidebar">
            <div class="sides-widget">
                <div class="sides-widget-header bg-primary">
                    <div class="agent-photo" v-if="props.item?.manager_image">
                      <img :src="props.item.manager_image" alt="manager_image">
                    </div>
                    <div class="sides-widget-details">
                        <h4 class="px-2"><router-link to="#">{{ props.item?.manager_name || $t('No Manager provided') }}</router-link></h4>
                        <span><i class="lni-phone-handset"></i>{{ props.item?.phone || $t('No phone provided') }}</span>
                    </div>
                    <div class="clearfix"></div>
                </div>
                
                <div class="sides-widget-body simple-form">
                    <div class="form-group">
                        <label>{{ $t('email') }}</label>
                        <input type="text" v-model="name" class="form-control" :placeholder="$t('your email')">
                    </div>
                    <div class="form-group">
                        <label>{{ $t('phone') }}</label>
                        <input type="text" v-model="phone" class="form-control" :placeholder="$t('phone')">
                    </div>
                    <div class="form-group">
                        <label>{{ $t('description') }}</label>
                        <textarea class="form-control" v-model="description"></textarea>
                    </div>
                    <button class="btn btn-primary fw-medium rounded full-width" @click="sendEmail">{{ $t('submit') }}</button>
                </div>
            </div>
            
            <div class="sides-widget">
                <div class="sides-widget-header bg-primary">
                    <div class="sides-widget-details">
                        <h4>{{ $t('to contact with ruqm') }}</h4>
                    </div>
                    <div class="clearfix"></div>
                </div>
                
                <div class="sides-widget-body simple-form">
                    <div class="form-group">
                        <div class="input-with-icon">
                            <input type="text" class="form-control" :placeholder="$t('Syria Aleppo')">
                        </div>
                    </div>
                    
                    <div class="form-group">
                        <div class="input-with-icon">
                            <input type="text" class="form-control" :placeholder="$t('phone')">
                        </div>
                    </div>
                    
                    <div class="form-group">
                        <div class="input-with-icon">
                            <input type="text" class="form-control" :placeholder="$t('email')">
                        </div>
                    </div>
                    
                    <button class="btn btn-primary fw-medium rounded full-width">{{ $t('ContactUs') }}</button>
                </div>
            </div>
            
            <div class="sidebar-widgets">
                <h4>{{ $t('related company') }}</h4>
                
                <div class="sidebar_featured_property">
                    <div v-for="item1 in stands" :key="item1.id" class="sides_list_property">
                        <div class="sides_list_property_thumb">
                            <img :src="item1.logo" class="img-fluid" alt="company-image">
                        </div>
                        <div class="sides_list_property_detail">
                            <h4>
                              <button
                                type="button"
                                class="related-stand-link"
                                @click="handleStandClick(item1)"
                              >
                                {{ item1?.name || 'Stand Name' }}
                              </button>
                            </h4>
                        </div>
                    </div>
                </div>
                <div ref="scrollSentinel"></div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, ref, watch, computed,nextTick, onBeforeUnmount } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import { useI18n } from "vue-i18n"; 
import Swal from 'sweetalert2';
const { locale, t } = useI18n();

const name = ref("");
const phone = ref("");
const description = ref("");

const scrollSentinel = ref(null);
const observer = ref(null);

const props = defineProps({
  item: Object
});

const router = useRouter();

const messageToSend = computed(() => {
  return t('whatsappMessage', {
    exhibit: exhibitName.value,
    stand: props.item?.name || ''
  });
});
const stands = ref([]);
const exhibitName = ref("");
const loading = ref(false);

const pagination = ref({
  current_page: 1,
  total: 0,
  per_page: 4,
  last_page: 1
});
const fetchExhibitName = async () => {
  if (!props.item?.hall_id) return;

  try {
    const { data } = await axios.get(
      `/exhibits/hall/${props.item.hall_id}`
    );

    exhibitName.value = data?.Ename || "";
  } catch (err) {
    console.error(err);
  }
};
let requestId = 0;
const loadPage = async (page = 1) => {
  if (!props.item?.hall_id) return;

  const currentRequestId = ++requestId;
  const currentStandId = Number(props.item.id);
  const currentHallId = props.item.hall_id;

  try {
    loading.value = true;

    const { data } = await axios.get(
      `/${currentHallId}/stands`,
      {
        params: {
          page,
          limit: pagination.value.per_page,
          lang: locale.value
        }
      }
    );

    if (currentRequestId !== requestId) {
      return;
    }

    if (
      Number(props.item?.id) !== currentStandId ||
      props.item?.hall_id !== currentHallId
    ) {
      return;
    }

    const list = data?.data || [];

    const filteredList = list
      .filter(s => Number(s.id) !== currentStandId)
      .slice(0, pagination.value.per_page);

    if (page === 1) {
      stands.value = filteredList;
    } else {
      stands.value = [...stands.value, ...filteredList];
    }

    if (data?.meta) {
      pagination.value = {
        current_page: data.meta.current_page,
        total: data.meta.total,
        per_page: data.meta.per_page,
        last_page: data.meta.last_page
      };
    }

  } catch (err) {
    console.error("Stand fetch error:", err);
  } finally {
    if (currentRequestId === requestId) {
      loading.value = false;
    }
  }
};
const stopObserver = () => {
  if (observer.value) {
    observer.value.disconnect();
    observer.value = null;
  }
};
async function setupObserver() {
  stopObserver();

  await nextTick();

  const sentinel = scrollSentinel.value;

  if (!sentinel) return;

  observer.value = new IntersectionObserver(
    async (entries) => {
      if (
        entries[0].isIntersecting &&
        !loading.value &&
        pagination.value.current_page < pagination.value.last_page
      ) {
        await loadPage(pagination.value.current_page + 1);
      }
    },
    { threshold: 0.15 }
  );

  observer.value.observe(sentinel);
}
onBeforeUnmount(() => {
  stopObserver();
});
const handleStandClick = async (stand, event) => {
  event?.preventDefault();

  const slug = stand.slug?.[locale.value];

  if (!slug) {
    await router.push({ name: "NotFound" });
    return;
  }

  await router.push(
    `/${locale.value}/stand/${slug}`
  );
};

watch(
  () => props.item?.id,
  async (newId, oldId) => {
    if (!newId || newId === oldId) return;

    stopObserver();

    stands.value = [];

    pagination.value = {
      current_page: 1,
      total: 0,
      per_page: 4,
      last_page: 1
    };

    await Promise.all([
      loadPage(1),
      fetchExhibitName()
    ]);

    await setupObserver();
  },
  { immediate: true }
);
watch(locale, async () => {
  stopObserver();

  stands.value = [];

  pagination.value = {
    current_page: 1,
    total: 0,
    per_page: 4,
    last_page: 1
  };

  await Promise.all([
    loadPage(1),
    fetchExhibitName()
  ]);

  await setupObserver();
});
const sendEmail = async () => {
  try {
    await axios.post("/send", {
      email: name.value,
      phone: phone.value,
      description: description.value,
      stand_email: props.item?.email,
    },{
      headers: {
        'Accept-Language': locale.value, 
      }
    });

    name.value = '';
    phone.value = '';
    description.value = '';

    Swal.fire({
      title: t('successTitle'),
      text: t('successText'),
      icon: 'success',
      confirmButtonText: t('ok'),
      customClass: {
        confirmButton: 'swal-btn-success',
      },
    });
  } catch (error) {
    console.error("Error sending email:", error);
    
    Swal.fire({
      title: t('errorTitle'),
      text: t('errorText'),
      icon: 'error',
      confirmButtonText: t('tryAgain'),
       customClass: {
        confirmButton: 'swal-btn-error',
      },
    });
  }
};

const copyUrl = async () => {
  try {
    await navigator.clipboard.writeText(window.location.href);

    Swal.fire({
      icon: 'success',
      title: t('linkCopiedTitle'),
      text: t('linkCopiedText'),
      timer: 2000,
      showConfirmButton: false,
    });
  } catch (err) {
    console.error('Failed to copy:', err);
    Swal.fire({
      icon: 'error',
      title: t('errorTitle') || 'Error',
      text: t('errorText') || 'Could not copy link. Please try again.',
    });
  }
};
</script>
<style>
.swal-btn-success {
  background-color: #28a745; 
  color: white;
  border: none;
}

.swal-btn-success:hover {
  background-color: #218838;
}

.swal-btn-error {
  background-color: #dc3545;
  color: white;
  border: none;
}

.swal-btn-error:hover {
  background-color: #c82333;
}
.sides_list_property_detail h4 .related-stand-link {
  display: inline;
  padding: 0;
  margin: 0;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  text-align: inherit;
  cursor: pointer;
}

.sides_list_property_detail h4 .related-stand-link:hover {
  color: inherit;
}
</style>